import { useEffect } from 'react';
import { envConfig } from '../../config/envConfig';

const useDevToolsBlocker = () => {



  useEffect(() => {

    if (envConfig.isProd === false) {
      return () => {
        // console.log("Inspect Element allowed in Dev env");
      }
    }

    // Disabling the right click
    const handleContextMenu = (e: MouseEvent) => e.preventDefault();

    // Disabling keyboard shortcuts
    const handleKeyDown = (e: KeyboardEvent) => {

      if (envConfig.isProd) {
        //  F12
        if (e.key === 'F12') {
          e.preventDefault();
        }

        // Preventing Ctrl+Shift+I i.e Chrome DevTools
        if (e.ctrlKey && e.shiftKey && e.key === 'I') {
          e.preventDefault();
        }

        // Preventing  i.e. Ctrl+Shift+J Chrome DevTools
        if (e.ctrlKey && e.shiftKey && e.key === 'J') {
          e.preventDefault();
        }

        // Prevent Ctrl+Shift+C (Chrome DevTools)
        if (e.ctrlKey && e.shiftKey && e.key === 'C') {
          e.preventDefault();
        }

        // Preventing  Ctrl+U View Source
        if (e.ctrlKey && e.key === 'u') {
          e.preventDefault();
        }
      }


    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);


    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};

export default useDevToolsBlocker;